import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Button from 'components/common/Button';
import IconReports from 'components/icons/IconReports';

const styles = theme => ({
  root: {
    height: '80%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  typographySeparator: {
    position: 'relative',
    marginTop: 15,
    marginBottom: 15,
    color: theme.palette.primary.A400,
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '50%',
      right: '100%',
      marginRight: 10,
      width: 50,
      height: 1,
      backgroundColor: theme.palette.primary.A400,
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '50%',
      left: '100%',
      marginLeft: 10,
      width: 50,
      height: 1,
      backgroundColor: theme.palette.primary.A400,
    },
  },
  button: {
    marginTop: 20,
  },
  iconReports: {
    width: 70,
    height: 69,
    marginBottom: 31,
    marginTop: 24,
  },
});

const ReportsCreateEditFormEmpty = ({
  variant,
  onReportGenerate,
  classes,
}) => (
  <div className={classes.root}>
    <IconReports className={classes.iconReports} />
    <Typography
      variant="subheading"
      color="secondary"
    >
      {variant === 'claim' &&
        'Set Report Options to Search specific claim report'}
      {(variant === 'create' || variant === 'edit') &&
        'Set Report Filters to Generate custom report'}
      {variant === 'insurance' &&
        'Generate insurance companies usage report and Change services information (temporary unavailable)'}
    </Typography>
    {variant !== 'insurance' &&
      <Fragment>
        <Typography
          className={classes.typographySeparator}
          variant="subheading"
        >
          or
        </Typography>
        <Typography
          variant="subheading"
          color="secondary"
        >
          {variant === 'claim'
            ? 'you could generate the yesterday report'
            : 'you could generate the whole orders report'}
        </Typography>
      </Fragment>
    }
    <Button
      className={classes.button}
      variant="raised"
      color="primary"
      onClick={onReportGenerate}
      disabled={variant === 'insurance'}
    >
      Generate
    </Button>
  </div>
);

ReportsCreateEditFormEmpty.propTypes = {
  variant: PropTypes.oneOf(['create', 'edit', 'claim', 'insurance']).isRequired,
  onReportGenerate: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typographySeparator: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconReports: PropTypes.string.isRequired,
  }).isRequired,
};

ReportsCreateEditFormEmpty.defaultProps = {
  onReportGenerate: () => {},
};

export default withStyles(styles)(ReportsCreateEditFormEmpty);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsCreateEditForm/ReportsCreateEditFormEmpty.js